import { HomePageQueryDocument, HomePageQueryQuery } from '@medprev-web-app/api-graphql-client';

import { ApolloClient } from '@/graphql/apollo-client';

export async function getHomeConfig(): Promise<HomePageQueryQuery | undefined> {
  const { data } = await ApolloClient.query({
    query: HomePageQueryDocument,
  });

  return data!;
}
